// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"39fcfae5","93":"9c3d2a6c","453":"926f0775","538":"638f54b8","584":"69ce974d","595":"67d31da0","816":"85408968","934":"a0e8f48f"}[chunkId] + ".chunk.js";
};